<template>
  <div>
    <div class="flex items-center space-x-4">
      <h2>{{ isEditing ? "Editar" : "Agregar" }} dirección</h2>
    </div>

    <div v-if="!loading" class="card mt-2">
      <form v-if="states" @submit.prevent="save">
        <div class="form-grid">
          <div class="form-field">
            <label for="street">Calle</label>
            <input id="street" type="text" v-model="form.street" />
            <validation-errors :errors="errorFor('street')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="exterior_number">Número exterior</label>
            <input
              id="exterior_number"
              type="text"
              v-model="form.exterior_number"
            />
            <validation-errors
              :errors="errorFor('exterior_number')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="interior_number">Número interior(opcional)</label>
            <input
              id="interior_number"
              type="text"
              v-model="form.interior_number"
            />
            <validation-errors
              :errors="errorFor('interior_number')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="neighborhood">Colonia</label>
            <input id="neighborhood" type="text" v-model="form.neighborhood" />
            <validation-errors
              :errors="errorFor('neighborhood')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="city">Ciudad</label>
            <input id="city" type="text" v-model="form.city" />
            <validation-errors :errors="errorFor('city')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="state">Estado</label>
            <custom-input-select
              v-model="form.state_id"
              id="state"
              :options="getStateOptions()"
            />
            <validation-errors :errors="errorFor('state_id')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="zip_code">Código postal</label>
            <input id="zip_code" type="text" v-model="form.zip_code" />
            <validation-errors :errors="errorFor('zip_code')"></validation-errors>
          </div>
        </div>

        <primary-button type="submit" class="mt-10 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Agregar" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Address Form",

  data() {
    return {
      states: null,
      form: {
        street: "",
        exterior_number: "",
        interior_number: "",
        neighborhood: "",
        city: "",
        state_id: null,
        zip_code: "",
        branch_id: null,
      },
      loading: false,
      loadingForm: false,
      isEditing: false,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "clients");

    this.loadStates();

    if (this.$route.params.id) {
      this.isEditing = true;
      this.loadAddress();
    }
  },

  mixins: [validationErrors],

  methods: {
    async loadStates() {
      this.loading = true;

      try {
        this.states = await api.resources.getStates();
      } catch (error) {}

      this.loading = false;
    },

    async loadAddress() {
      this.loading = true;

      try {
        const address = await api.clients.getAddressById(this.$route.params.id);
        address.state_id = address.state.id;
        delete address.state;
        this.form = JSON.parse(JSON.stringify(address));
      } catch (error) {
        console.log(error);
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    getStateOptions() {
      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      this.states.forEach((state) => {
        options.push({
          value: state.id,
          label: state.name,
        });
      });

      return options;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createAddress();
      } else {
        this.updateAddress();
      }
    },

    validateForm() {
      this.errors = {};

      if (!this.form.street) {
        this.errors["street"] = ["Campo requerido"];
      }

      if (!this.form.exterior_number) {
        this.errors["exterior_number"] = ["Campo requerido"];
      }

      if (!this.form.exterior_number) {
        this.errors["exterior_number"] = ["Campo requerido"];
      }

      if (!this.form.city) {
        this.errors["city"] = ["Campo requerido"];
      }

      if (!this.form.state_id) {
        this.errors["state_id"] = ["Campo requerido"];
      }

      if (!this.form.zip_code) {
        this.errors["zip_code"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createAddress() {
      this.loadingForm = true;

      try {
        const response = await api.clients.createAddress(
          this.$route.params.clientId,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.back();
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },

    async updateAddress() {
      this.loadingForm = true;

      try {
        const response = await api.clients.updateAddress(
          this.$route.params.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.back();
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>